import type { SuperValidated } from 'sveltekit-superforms';
import { z } from 'zod';

const inquiry = z.enum(
  ['general_questions', 'dlct_guideline_and_licensing', 'cooperation_of_partnership', 'technical_issues'],
  {
    required_error: 'Inquiry is required',
  },
);

export type Inquiry = z.infer<typeof inquiry>;
export type SecondStepContactForm = SuperValidated<typeof secondStepContactForm>;

export const secondStepContactForm = z.object({
  inquiry_type: inquiry,
  message: z.string().min(1, 'Message is required'),
});
